import React from "react";
import FormInvalid from "./FormInvalid";
import DatePicker from "react-datepicker";

function FormGroupDateRange({
    startDate,
    endDate,
    label,
    errorStartDate,
    errorEndDate,
    handleChange,
}) {
    function renderErrors() {
        if (hasErrors()) {
            return [
                <FormInvalid key="start-date-error" message={errorStartDate} />,
                <FormInvalid key="end-date-error" message={errorEndDate} />,
            ];
        }
    }

    function hasErrors() {
        return !!errorEndDate || !!errorStartDate;
    }
    return (
        <div className={`form-group form-dates ${hasErrors() ? 'is-invalid' : ''}`}>
            <label>{label}</label>
            <div>
                <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={handleChange}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                />
            </div>
            {renderErrors()}
        </div>
    );
}

export default FormGroupDateRange;
